import React from "react";
import { AppWrap } from "../../wrapper";

import "./Title.scss";

const Title = () => {
  return (
    <div>
      <h1>Title</h1>
    </div>
  );
};

export default AppWrap(Title, "title", "");
